module.exports = __webpack_public_path__ + "img/box-banner-agenda.ae32590e.png";